import React, { useEffect } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
var termsDataEn = [{
  title: 'Applicability',
  points: ['Ensure devices and accounts are secure and compliant.', 'Do not use the services while driving or operating a vehicle.']
}, {
  title: 'Company Rights',
  points: ['Chicken Kickers may change, update, or terminate online services at any time.', 'All content and technology are proprietary and protected.']
}, {
  title: 'Loyalty Program & Offers',
  points: ['Offers are time-limited and subject to availability.', 'Participation in loyalty programs requires a registered account.', 'Suspicious or fraudulent activity can lead to account suspension.']
}, {
  title: 'How Information is Used',
  points: ['Process orders and payments.', 'Provide personalized content and promotions (with consent).', 'Customer service and communications.', 'Business analysis and improvement.', 'Fraud prevention and legal compliance.']
}, {
  title: 'Prohibited Activities',
  points: ['Users must not:', 'Use services for illegal purposes.', 'Copy, modify, or reverse-engineer any part of the service.', 'Use bots or scraping tools to access the platform.']
}, {
  title: 'Communication Preferences',
  points: ['Users can manage how they receive messages (email, SMS, push notifications).', 'Transactional messages may still be sent even if marketing is disabled.']
}];
var termsDataAr = [{
  title: 'التطبيق',
  points: ['تأكد من أن الأجهزة والحسابات آمنة ومتوافقة.', 'لا تستخدم الخدمات أثناء القيادة أو تشغيل مركبة.']
}, {
  title: 'حقوق الشركة',
  points: ['يحق لتشيكن كيكرز تغيير أو تحديث أو إنهاء الخدمات الإلكترونية في أي وقت.', 'جميع المحتويات والتقنيات مملوكة ومحمية.']
}, {
  title: 'برنامج الولاء والعروض',
  points: ['العروض محدودة بفترة زمنية وخاضعة للتوافر.', 'تتطلب المشاركة في برامج الولاء وجود حساب مسجل.', 'قد يؤدي النشاط المشبوه أو الاحتيالي إلى تعليق الحساب.']
}, {
  title: 'كيفية استخدام المعلومات',
  points: ['معالجة الطلبات والمدفوعات.', 'تقديم محتوى وعروض ترويجية مخصصة (بعد الحصول على موافقتك عند الاقتضاء).', 'تقديم خدمات الدعم والتواصل مع العملاء.', 'تحليل الأداء وتحسين الخدمات والعمليات.', 'منع الاحتيال والامتثال للأنظمة والقوانين المعمول بها.']
}, {
  title: 'الأنشطة المحظورة',
  points: ['يجب على المستخدمين عدم:', 'استخدام الخدمات لأغراض غير مشروعة.', 'نسخ أو تعديل أو إجراء هندسة عكسية لأي جزء من الخدمة.', 'استخدام برامج الروبوت أو أدوات الاستخراج للوصول إلى المنصة.']
}, {
  title: 'تفضيلات التواصل',
  points: ['يمكن للمستخدمين إدارة كيفية استلامهم للرسائل (البريد الإلكتروني، الرسائل النصية، الإشعارات الفورية).', 'قد تستمر الرسائل المتعلقة بالعمليات حتى في حالة تعطيل الرسائل التسويقية.']
}];
export default function TermsAndConditionsView() {
  var {
    isAr
  } = useLanguage();
  var data = isAr ? termsDataAr : termsDataEn;
  var headerTitle = isAr ? 'الشروط والأحكام – تشيكن كيكرز' : 'Terms & Conditions - Chicken Kickers';
  var entityLabel = isAr ? 'الجهة: تشيكن كيكرز' : 'Entity: Chicken Kickers';
  var locationLabel = isAr ? 'العنوان: بجوار مسجد الخير، أمام مركب ستاسيا، شارع المشاية السفلية، المنصورة' : 'Location: Beside Al Khayr Mosque, in front of Stasia Boat, El Mashaya El Soffelya Street, Mansoura';
  var contactLabel = isAr ? 'رقم التواصل: 15497' : 'Contact: 15497';
  useEffect(() => {
    if (typeof window !== 'undefined') {
      var mainElement = document.querySelector('main');
      if (mainElement) {
        mainElement.classList.add('mt-[12rem]', 'md:mt-0');
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "page-width max-w-[120rem] text-[1.6] md:text-[1.8rem] mb-[10rem] md:mb-[20rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-[#f2f2f2] p-[3.5rem] py-[2.5rem] rounded-[1.5rem] font-rubik text-black"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-[92rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leading-[2.25rem] md:leading-[2.5rem]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#C60910] text-[1.8rem] md:text-[2rem] font-medium uppercase font-zoom-pro-normal"
  }, headerTitle), /*#__PURE__*/React.createElement("p", {
    className: "text-[1.6rem] mt-[1rem]"
  }, entityLabel, /*#__PURE__*/React.createElement("br", null), locationLabel, /*#__PURE__*/React.createElement("br", null), contactLabel)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-[2rem] mt-[2rem]"
  }, data.map((section, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "leading-[2.25rem] md:leading-[2.5rem]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#C60910] text-[1.8rem] md:text-[2rem] font-medium uppercase font-zoom-pro-normal"
  }, section.title), i === 2 && /*#__PURE__*/React.createElement("p", {
    className: "text-[1.6rem] mt-[1rem] -mb-[1rem]"
  }, isAr ? ' تنطبق الشروط التالية:' : ' The following conditions apply:'), i === data.length - 1 && /*#__PURE__*/React.createElement("p", {
    className: "text-[1.6rem] mt-[1rem]"
  }, entityLabel, /*#__PURE__*/React.createElement("br", null), locationLabel, /*#__PURE__*/React.createElement("br", null), contactLabel), /*#__PURE__*/React.createElement("ul", {
    className: section.className || 'max-w-auto'
  }, section.points.map((point, j) => /*#__PURE__*/React.createElement("li", {
    key: j,
    className: "list-disc  text-[1.6rem] leading-[2rem] ".concat(j === 0 ? 'mt-[1rem]' : 'mt-[0.25rem]', " ").concat(!isAr ? 'ml-[2.5rem]' : 'mr-[2.5rem]', " ")
  }, point)))))))));
}
;